import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"fill-current\" id=\"minus\"><path d=\"M0 10.29h24v3.43H0z\" data-name=\"Icons-/-Large-/-Primary-/-Minus\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol